/**
 * Rounds a raw, possibly fractional-penny cost (e.g. a mileage cost computed as
 * mileage * rate-per-mile) to the nearest whole penny.
 *
 * This is the single canonical rounding rule for turning a raw cost into a
 * whole-penny amount for display or summing. Every call site that needs to
 * round a mileage cost (or any other fractional-penny figure) to whole pence
 * should use this rather than reimplementing its own rounding/division logic,
 * so that a given value rounds identically everywhere it's used.
 *
 * Assumes cost is non-negative: Math.round rounds negative half-values toward
 * +Infinity (e.g. Math.round(-0.5) === -0), which differs from the Go
 * roundMileageCost helper's behaviour (math.Round(-0.5) === -1). Mileage
 * costs are always >= 0 today, so this hasn't been observed to matter in
 * practice.
 */
export function roundToPence(cost: number): number {
  return Math.round(cost);
}
